import React, { useEffect, useState } from "react";
import { Table } from "antd";
import getBenefitColumns from "../../../const/Columns/getBenefitColumns";
import { deleteLocationsServer } from "../../../apis/locationsApi";
import { Link } from "react-router-dom";
import { getAllBenefits } from "../../../apis/benefits";

const Benefits = () => {
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [filteredList, setFilteredList] = useState([]);

  useEffect(() => {
    fetchLocations();
  }, []);

  useEffect(() => {
    if (locations?.length > 0) {
      const filtered = locations?.filter((ben) =>
        ben.name?.toLowerCase().includes(searchText.toLowerCase()),
      );
      setFilteredList(filtered);
    }
  }, [searchText, locations]);

  const fetchLocations = async () => {
    try {
      const res = await getAllBenefits();
      setLocations(res.result);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const deleteLocations = async (id) => {
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this Location?",
    );
    if (isConfirmed) {
      await deleteLocationsServer(id);
      setLoading(true);
      fetchLocations();
    }
  };

  const columns = getBenefitColumns(deleteLocations);
  return (
    <>
      <div className="main-wrapper">
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="d-flex  justify-content-between  align-items-center">
              <Link to="/AddBenefits" className="btn add-new btn-primary mb-3">
                Create Benefit
              </Link>
              {/* Search Input */}
              <input
                type="text"
                placeholder="Search by title"
                className="form-control w-25"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>
            {loading ? (
              <div>Loading...</div>
            ) : (
              <div className="table-respoinsive">
                <Table
                  columns={columns}
                  dataSource={
                    searchText && filteredList?.length > 0
                      ? filteredList
                      : locations?.length > 0
                        ? locations
                        : []
                  }
                  className="table-striped "
                  rowKey={(record) => record.id}
                  // scroll={{ y: 400 }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Benefits;
